/*
https://www.notion.so/winasone/Tracking-Components-Events-outside-of-buttons-and-links-3643ab5acbc64e068a31f52856f81605
Component Name: Free Game Filter    (Populates eVar90 in Adobe)
Component Option: Sort By           (Populates eVar91 in Adobe)
Component Value: A-Z                (Populates eVar92 in Adobe)
Component Type: Dropdown            (Populates eVar93 in Adobe)
Interaction Type: Select            (Populates eVar94 in Adobe)
Component Location: Middle          (Populates eVar95 in Adobe)
*/


export const eventDispatcher = (
    eVar90: string, 
    eVar91: string, 
    eVar92: string, 
    eVar93: string, 
    eVar94: string, 
    eVar95= "Top"
) => {
    const componentEvent = new CustomEvent('componentInteraction', {
        bubbles: true, 
        detail: { 
            componentName: eVar90, 
            componentOption: eVar91, 
            componentValue: eVar92, 
            componentType: eVar93, 
            interactionType: eVar94, 
            componentLocation: eVar95
        }
    });
    
    window.dispatchEvent(componentEvent);
    return;
}
